<!-- <form [formGroup]="clientForm" (ngSubmit)="onSubmit()"> -->
<form [formGroup]="clientForm">

    <div class="searchbar-whereapp">
        <!-- <div id="salva-modifiche-div">
            <button id="salva-modifiche-button" type="submit" [disabled]="!clientForm.valid">
                <mat-icon aria-hidden="false" id="salva-modifiche-icon">save</mat-icon>
                <span id="salva-modifiche-text">Salva modifiche</span>
            </button>
        </div> -->
        <button mat-flat-button id="back-toolbar-button" (click)="onBackButtonClick()">
            <mat-icon [inline]="true">chevron_left</mat-icon>
            Indietro
        </button>
    </div>

    <mat-progress-bar mode="indeterminate" style="position: absolute; top: 68px; z-index: 27;" [hidden]="!this.loading">
    </mat-progress-bar>

    <div *ngIf="senderDetail" id="main-container">

        <div class="container">
            <!-- <h3 class="mb-0">Anagrafica:</h3> -->
            <h1 class="mat-display-1 mb-2">
                <img src="data:image/png;base64,{{ clientForm.value.sender.logo }}" width="65px" height="65px"
                    class="mr-2" style="border-radius: 50%;" (click)="onEditLogoButtonClick()" id="logo-img"/>
                {{ clientForm.value.sender.name }}
            </h1>
            <h2 class="mat-caption">email: {{ clientForm.value.sender.email }}</h2>
            <p class="mat-body">descrizione: {{ clientForm.value.sender.descr }}</p>
            <p class="mat-body">descrizione opzionale: {{ clientForm.value.sender.descrOpt }}</p>
            <h2 class="mat-body-strong">firma: {{ clientForm.value.sender.firma }}</h2>
            <h2 class="mat-body-strong">
                validità contratto: {{ clientForm.value.sender.contractStartDate | date:"shortDate" }} - {{
                clientForm.value.sender.contractEndDate | date:"shortDate" }}
            </h2>
            <!-- <h4 id="last-modification-field" class="mat-caption">
                ultima modifica: {{ clientForm.value.sender.modifiedDate | date:"short" }}</h4>
            <div style="height: 30px;"></div> -->
            <hr class="mb-0">
            <button mat-flat-button aria-label="Edit sender button" class="edit-button"
                (click)="onEditSenderButtonClick()" type="button" matTooltip="Modifica anagrafica"
                [matTooltipShowDelay]="600">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-flat-button aria-label="Edit sender button" class="save-button"
                (click)="saveAnagraficaButtonClick()" type="button" matTooltip="Salva anagrafica"
                [matTooltipShowDelay]="600">
                <mat-icon>save</mat-icon>
            </button>
        </div>

        <!-- <div class="container" formGroupName="sender">
            <h3 class="mb-0">Contratto:</h3>
            <mat-form-field class="date-field">
                <mat-label>Inizio</mat-label>
                <input matInput [matDatepicker]="picker1" formControlName="contractStartDate">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1 disabled="false"></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="date-field">
                <mat-label>Scadenza</mat-label>
                <input matInput [matDatepicker]="picker2" formControlName="contractEndDate">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2 disabled="false"></mat-datepicker>
            </mat-form-field>
            <hr class="mb-0">
            <button mat-flat-button aria-label="Edit sender button" class="save-button"
                (click)="saveContrattoButtonClick()" type="button" matTooltip="Salva contratto"
                    [matTooltipShowDelay]="600">
                <mat-icon>save</mat-icon>
            </button>
        </div> -->

        <div id="categories-container" class="container min-height">
            <h3 class="mb-0">Categorie:</h3>
            <h4 class="list-title left">Disponibili</h4>
            <div class="list-container left">
                <ng-container *ngFor="let item of availableCategories;">
                    <span *ngIf="!item.selected;" (click)="onItemClick(item)" class="unselectable"
                        [class.chosen]="item.chosen">
                        {{ item.categoryName }}</span>
                </ng-container>
            </div>
            <button mat-stroked-button class="add-remove-button" type="button" (click)="onSwitchClick()">
                <mat-icon [inline]="true" style="color: grey;">swap_horiz</mat-icon>
            </button>
            <h4 class="list-title right">Selezionate</h4>
            <div class="list-container right">
                <ng-container *ngFor="let item of availableCategories;">
                    <span *ngIf="item.selected;" (click)="onItemClick(item)" class="unselectable"
                        [class.chosen]="item.chosen">
                        {{ item.categoryName }}</span>
                </ng-container>
            </div>
            <button mat-flat-button aria-label="Edit sender button" class="save-button"
                (click)="saveCategoriesButtonClick()" type="button" matTooltip="Salva categorie"
                [matTooltipShowDelay]="600">
                <mat-icon>save</mat-icon>
            </button>
        </div>

        <div id="areas-container" class="container min-height">
            <h3 class="mb-0">Aree:</h3>
            <h4 class="list-title left">Disponibili</h4>
            <div class="list-container left">
                <ng-container *ngFor="let item of availableAreas;">
                    <span *ngIf="!item.selected;" (click)="onItemClick(item)" class="unselectable"
                        [class.chosen]="item.chosen">
                        {{ item.areaName }}</span>
                </ng-container>
            </div>
            <button mat-stroked-button class="add-remove-button" type="button" (click)="onAreasSwitchClick()">
                <mat-icon [inline]="true" style="color: grey;">swap_horiz</mat-icon>
            </button>
            <h4 class="list-title right">Selezionate</h4>
            <div class="list-container right">
                <ng-container *ngFor="let item of availableAreas;">
                    <span *ngIf="item.selected;" (click)="onItemClick(item)" class="unselectable"
                        [class.chosen]="item.chosen">
                        {{ item.areaName }}</span>
                </ng-container>
            </div>
            <button mat-flat-button aria-label="Edit sender button" class="save-button"
                (click)="saveAreasButtonClick()" type="button" matTooltip="Salva aree"
                [matTooltipShowDelay]="600">
                <mat-icon>save</mat-icon>
            </button>
        </div>

    </div>

</form>

<div class="loading" *ngIf="sub === true">
</div>